export function sacList () {
  return {
    'none': 'Aucun',
    'depot_sac_om': 'Sac ordure ménagère',
    'depot_sac_valorisable': 'Sac valorisable',
  }
}
export function evenementList () {
  return {
    'none': 'Aucun',
    'COLLECTE_OU_DEBORDEMENT_BAC': 'Collecte ou debordement bac',
    'COLLECTE_OU_DEBORDEMENT_CORBEILLE': 'Collecte ou debordement corbeille',
    'LAVAGE': 'Lavage',
  }
}
export function matList () {
  return [ '1', '2', ]
}
export function arrondList () {
  return [ '1', ] // , '2'
}

export function anomalieList () {
  return {
    'none': 'Aucun',
    'debordement_bac': 'Débordement bac',
    'debordement_corbeille': 'Débordement corbeille',
    'depot_sauvage': 'Dépôt Sauvage',
    'desherbage': 'Désherbage',
    'encombrants': 'Encombrants',
    'feuilles_mortes': 'Feuilles mortes',
    'mobilier_urbain': 'Mobilier Urbain',
    'salissures': 'Salissures',
    'assainissement': 'Assainissement',
    'COLLECTE_OU_DEBORDEMENT_CORBEILLE': 'Collecte ou debordement corbeille',
    'COLLECTE_OU_DEBORDEMENT_BAC': 'Collecte ou debordement bac',
    'incendie': 'Incendie',
  }
}

export function evenementDetailList () {
  return {
    'CORBEILLE': 'Corbeille',
    'CANIBOX': 'Canibox',
    'BAC': 'Bac',
    'ABRI_BUS': 'Abri bus',
    'PLAQUE_EGOUT': 'Plaque d\'égoût',
    'TABLEAU_ELECTRIQUE': 'Tableau électrique',
    'AUTRE': 'Autre',
    'GRAVATS': 'Gravats',
    'CARTONS': 'Cartons',
    'ORDURES_MENAGERS': 'Ordures Ménagères',
    'ORDURES_MENAGERES': 'Ordures Ménagères',
    'HUILE_PRODUITS_GRAS': 'Huile et produits gras',
    'PEINTURE': 'Peinture',
    'PRESENCE_RATS': 'Presence de rats',
    'ODEUR_RESEAU': 'Odeur réseau',
    'AVALOIR_BOUCHE': 'Avaloir bouché',
  }
}

export function evenementEtatList () {
  return {
    'casse': 'cassé',
    'tague': 'tagué',
    'sale': 'sale',
    'autre': 'autre',
  }
}

export function genreDisplayList () {
  return [
    'DEBUT_DE_SERVICE',
    'FIN_DE_SERVICE',
    'PAUSE',
    'REPRISE',
  ]
}



// WEBPACK FOOTER //
// ./src/const/index.js